var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPiece4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 179.55,
    height: 102.592,
    viewBox: "0 0 179.55 102.592",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_32",
    "data-name": "Trac\\xE9 32",
    d: "M294.07,424s28.138,4.327,10.822,24.891-59.523,5.415-73.592-1.08-33.552-5.415-47.621,0-38.96-1.08-37.88-20.563,3.247-19.484-5.407-33.552-6.495-23.811,3.247-33.552",
    transform: "translate(-132.975 -358.726)",
    fill: "none",
    stroke: "#f3f3f3",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPiece4);
export default __webpack_public_path__ + "static/media/piece-4.45e7f1b1cad438d81258b72359a484fa.svg";
export { ForwardRef as ReactComponent };